// Textos que se repiten en varias pantallas y tienen que decir lo mismo en todas.

// La frase sobre el audio del mostrador (P14, decisión de Kevin del 27-sep-2026). Reemplaza a «No graba
// conversaciones…», que no era cierta: el sistema sí guarda el audio y se puede escuchar en El oído
// (`components/AudioPlayer.tsx`). Dice solo lo que el código hace —qué detecta (`faltante` y
// `venta_posible` en `apps/api/src/repos/audio.ts`), quién escucha (encargado su botica, dueño todas),
// quién borra (`POST /audio/purgar`, solo el dueño)— y el veto del proyecto. Si alguna de esas cosas
// cambia, esta frase cambia en el mismo cambio. Va en Hoy, Ajustes y El oído.
export const FRASE_AUDIO =
  "El teléfono del mostrador graba el audio para anotar lo que piden y no hay, y las ventas que escuchó pero no se registraron. El encargado y el dueño pueden escucharlo en El oído, y el dueño puede borrarlo todo. No se usa para vigilar al personal.";
